import Icon from '../Icon/Icon';

const PrevIcon = () => <Icon color='#676D77' iconName='IconChevronLeft' />;
const NextIcon = () => <Icon color='#676D77' iconName='IconChevronRight' />;

const LastIcon = () => <Icon color='#676D77' iconName='IconChevronsRight' />;
const FirstIcon = () => <Icon color='#676D77' iconName='IconChevronsLeft' />;

export { FirstIcon, LastIcon, NextIcon, PrevIcon };
